<div class="dialog-shell">
  <div class="dialog-header">
    <div class="dialog-badge" aria-hidden="true">
      <mat-icon>edit</mat-icon>
    </div>

    <div class="dialog-copy">
      <p class="dialog-eyebrow">Biblia</p>
      <h2 class="dialog-title">{{ dialogTitle }}</h2>
      <p class="dialog-description">
        {{ dialogDescription }}
      </p>
      <p *ngIf="contextText" class="dialog-context">
        {{ contextText }}
      </p>
    </div>
  </div>

  <div
    *ngIf="state === 'LOADING'; else editState"
    class="dialog-state dialog-state--loading"
  >
    <div class="dialog-state__spinner">
      <mat-spinner diameter="38"></mat-spinner>
    </div>

    <h3>Guardando cambios</h3>
    <p>
      Estamos actualizando la Biblia. Mantén esta ventana abierta hasta que el
      proceso termine.
    </p>
  </div>

  <ng-template #editState>
    <div class="dialog-content">
      <div
        *ngIf="state === 'ERROR'"
        class="dialog-alert"
        role="alert"
        aria-live="polite"
      >
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong>No se pudo guardar</strong>
          <p>{{ errorMessage }}</p>
        </div>
      </div>

      <form class="dialog-form" (ngSubmit)="save()" novalidate>
        <mat-form-field
          appearance="outline"
          class="dialog-field"
          [ngClass]="
            isTimeField ? 'dialog-field--time' : 'dialog-field--textarea'
          "
        >
          <mat-label>{{ fieldLabel }}</mat-label>

          <input
            *ngIf="isTimeField; else textField"
            matInput
            type="time"
            name="valueProp"
            step="60"
            [(ngModel)]="valueProp"
            (ngModelChange)="onValueChange()"
            [disabled]="state === 'LOADING'"
          />

          <ng-template #textField>
            <textarea
              matInput
              rows="5"
              name="valueProp"
              [(ngModel)]="valueProp"
              (ngModelChange)="onValueChange()"
              [disabled]="state === 'LOADING'"
              [placeholder]="fieldHint"
            ></textarea>
          </ng-template>

          <mat-hint>{{ fieldHint }}</mat-hint>
        </mat-form-field>

        <div class="dialog-actions">
          <button
            type="submit"
            class="buttonPrimary dialog-action-button dialog-action-button--primary"
            [disabled]="isSaveDisabled"
          >
            {{ state === "ERROR" ? "Reintentar" : "Guardar cambios" }}
          </button>

          <button
            type="button"
            class="buttonSecundary dialog-action-button dialog-action-button--secondary"
            (click)="close()"
            [disabled]="state === 'LOADING'"
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</div>
